import { render, staticRenderFns } from "./AuthorJinNangLevelOneContainer.vue?vue&type=template&id=0570cf8b&scoped=true"
import script from "./AuthorJinNangLevelOneContainer.vue?vue&type=script&lang=js"
export * from "./AuthorJinNangLevelOneContainer.vue?vue&type=script&lang=js"
import style0 from "./AuthorJinNangLevelOneContainer.vue?vue&type=style&index=0&id=0570cf8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570cf8b",
  null
  
)

export default component.exports